import { PropsWithChildren } from "react";
import { Header } from "@tanstack/react-table";
import {
  ArrowDownUp,
  ArrowDownWideNarrow,
  ArrowUpNarrowWide,
} from "lucide-react";

interface HeaderColumnProps<TData>
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {
  isFirst?: boolean;
  header: Header<TData, any>;
}

export const HeaderColumn = <TData,>({
  children,
  isFirst,
  header,
  ...props
}: HeaderColumnProps<TData>) => {
  return (
    <div
      className="flex flex-row items-center justify-center h-10 absolute, py-1 px-2 font-bold bg-white"
      {...props}
      // boxShadow="0 0 0 0.5px #E2E8F0"
    >
      {children}
      <div
        onClick={header.column.getToggleSortingHandler()}
        style={{ cursor: "pointer" }}
      >
        {header.column.getCanSort()
          ? {
              asc: <ArrowUpNarrowWide size="14" strokeWidth={2} />,
              desc: <ArrowDownWideNarrow size="14" strokeWidth={2} />,
            }[header.column.getIsSorted() as string] ?? (
              <ArrowDownUp size="14" strokeWidth={2} />
            )
          : null}
      </div>
    </div>
  );
};
